export const dashboard = { value: 'dashboard', label: 'dashboard' };
export const reports = { value: 'reports', label: 'reports' };
export const scheduledReports = { value: 'scheduled-reports', label: 'scheduled reports' };
